import {createHttp} from '@shared/http/createAxios'

const axios = createHttp({
  baseURL: process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000',
})

export default axios
